import { render } from "./BlockVoletClean.vue?vue&type=template&id=09cd6109"
import script from "./BlockVoletClean.vue?vue&type=script&lang=js"
export * from "./BlockVoletClean.vue?vue&type=script&lang=js"

import "./BlockVoletClean.vue?vue&type=style&index=0&id=09cd6109&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__